export const QueryKeys = {
  PROFILE: 'profile',
  CUSTOMERS_LIST: 'customers_list',
  CUSTOMER_DETAILS: 'customer_details',
  DASHBOARD_DATA: 'dashboard_data',
  AFFILIATES: 'affiliates',
  CREDIT_CARD: 'credit_card',
  DOCUMENTS: 'documents',
  ACTIVITY_LOGS: 'activity_logs',
  GET_CONTACT_SHARE_FILES: 'get_contact_share_files'
}
